module.exports = __webpack_public_path__ + "img/hotelFamily-2.febffd52.jpg";